import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { delete_mobility_plan } from '../../assets/img';
import { POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME } from '../../pages/TalentReviewAgenda/components/TalentReviewMobilityPlan/PositionMobilityPlanDetailSelection/constants';

const SortableItem = (props) => {
  const { item, setPositionSelected, positionSelected, isView, styles, color, type, height, handleDelete, mobilitySettings } = props;
  const { attributes, listeners, setNodeRef } = useSortable({
    id: props.id,
    data: { ...item, isMobility: true, typeMobility: type },
  });
  const itemStyle = {
    // transform: CSS.Transform.toString(transform),
    // transition,
    cursor: 'grab',
    margin: '5px 0',
    height,
    borderLeftColor: color === '#00A19C' ? '#66B2C4' : color,
    color,
    boxShadow:
      positionSelected?.position_code === item.position_code && type === positionSelected?.typeMobility
        ? '0px 4px 6px 0px rgba(52, 63, 75, 0.10), 0px 2px 4px 0px rgba(52, 63, 75, 0.06)'
        : 'unset',
  };

  return (
    <div
      id={`sortable-item-${props.id}`}
      style={itemStyle}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      // disabled={isReadOnly}
      className={styles.positionName}
      onKeyDown={() => {}}
      onMouseDown={() => {
        if (type && type !== 'end_state') {
          setPositionSelected(
            positionSelected?.position_code === item.position_code && positionSelected?.typeMobility === type
              ? null
              : { position_code: item.position_code, typeMobility: type }
          );
        }
      }}
    >
      <div>
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.POSITION_NAME) && item.position_name}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.JOB_GRADE) && (
          <span style={{ fontWeight: 400 }}>({item.job_grade})</span>
        )}

        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.POSITION_ID) && (
          <div className={styles.positionMobilityPlanDetail}>
            Position ID : <span style={{ fontWeight: 400 }}>{item.position_code}</span>
          </div>
        )}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.DEPARTMENT) && (
          <div className={styles.positionMobilityPlanDetail}>
            Department : <span style={{ fontWeight: 400 }}>{item.department}</span>
          </div>
        )}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.SECTOR) && (
          <div className={styles.positionMobilityPlanDetail}>
            Sector : <span style={{ fontWeight: 400 }}>{item.sector}</span>
          </div>
        )}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.DIVISION) && (
          <div className={styles.positionMobilityPlanDetail}>
            Division : <span style={{ fontWeight: 400 }}>{item.division}</span>
          </div>
        )}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.OPU) && (
          <div className={styles.positionMobilityPlanDetail}>
            OPU : <span style={{ fontWeight: 400 }}>{item.opu}</span>
          </div>
        )}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.BUSINESS) && (
          <div className={styles.positionMobilityPlanDetail}>
            Business : <span style={{ fontWeight: 400 }}>{item.business}</span>
          </div>
        )}
        {mobilitySettings.map((m) => m.value || m).includes(POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.CURRENT_INCUMBENT) && (
          <div className={styles.positionMobilityPlanDetail}>
            Current Incumbent : <span style={{ fontWeight: 400 }}>{item.current_incumbent}</span>
          </div>
        )}
      </div>
      {!isView && (
        <img
          src={delete_mobility_plan}
          alt="delete"
          onClick={() => handleDelete(item.position_code)}
          onMouseDown={() => {
            handleDelete(item.position_code);
            if (type && type !== 'end_state') {
              setPositionSelected(null);
            }
          }}
          onKeyDown={() => {}}
        />
      )}
    </div>
  );
};

export default SortableItem;
